import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    niePassport: '',
    country: '',
    province: '',
    appointmentType: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    phone: '',
    niePassport: '',
    country: '',
    province: '',
    appointmentType: ''
  });

  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'name':
        if (!value.trim()) {
          error = 'El nombre es obligatorio';
        } else if (value.trim().length < 2) {
          error = 'El nombre debe tener al menos 2 caracteres';
        }
        break;
      case 'phone':
        if (!value.trim()) {
          error = 'El teléfono es obligatorio';
        } else if (!/^[+]?[0-9\s\-()]{9,}$/.test(value.trim())) {
          error = 'Ingresa un número de teléfono válido';
        }
        break;
      case 'niePassport':
        if (!value.trim()) {
          error = 'El NIE o pasaporte es obligatorio';
        } else if (value.trim().length < 3) {
          error = 'Ingresa un NIE o pasaporte válido';
        }
        break;
      case 'country':
        if (!value.trim()) {
          error = 'El país es obligatorio';
        } else if (value.trim().length < 2) {
          error = 'Ingresa un país válido';
        }
        break;
      case 'province':
        if (!value.trim()) {
          error = 'La provincia es obligatoria';
        } else if (value.trim().length < 2) {
          error = 'Ingresa una provincia válida';
        }
        break;
      case 'appointmentType':
        if (!value) {
          error = 'Debes seleccionar un tipo de cita';
        }
        break;
      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    setErrors({
      ...errors,
      [name]: error
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate all fields
    const newErrors = {};
    let hasErrors = false;

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) {
        newErrors[key] = error;
        hasErrors = true;
      }
    });

    if (hasErrors) {
      setErrors(newErrors);
      return;
    }

    // If no errors, proceed with submission
    const message = `Hola, me gustaría solicitar una cita.\n\nNombre: ${formData.name}\nTeléfono: ${formData.phone}\nNIE/Pasaporte: ${formData.niePassport}\nPaís: ${formData.country}\nProvincia: ${formData.province}\nTipo de cita: ${formData.appointmentType}`;
    const whatsappUrl = `https://wa.me/34632215886?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-bg-image">
        <img 
          src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80" 
          alt="Contacto para citas de extranjería" 
          className="contact-image"
        />
        <div className="contact-image-overlay"></div>
      </div>
      <div className="container">
        <h2 className="section-title">Contacto</h2>
        <p className="section-subtitle">Contáctanos para gestionar tu cita</p>
        <div className="contact-content">
          <div className="contact-methods">
            <a 
              href="https://wa.me/34632215886?text=Hola,%20me%20gustaría%20solicitar%20una%20cita%20de%20extranjería" 
              className="whatsapp-contact-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="whatsapp-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Contactar por WhatsApp
            </a>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nombre</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                placeholder="Ej: Juan Pérez"
                className={errors.name ? 'error-input' : ''}
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="phone">Teléfono</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                placeholder="Ej: +34 612 345 678"
                className={errors.phone ? 'error-input' : ''}
              />
              {errors.phone && <span className="error-message">{errors.phone}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="niePassport">NIE / Número de Pasaporte</label>
              <input
                type="text"
                id="niePassport"
                name="niePassport"
                value={formData.niePassport}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                placeholder="Ej: X1234567Z o AB123456"
                className={errors.niePassport ? 'error-input' : ''}
              />
              {errors.niePassport && <span className="error-message">{errors.niePassport}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="country">País</label>
              <input
                type="text"
                id="country"
                name="country"
                value={formData.country}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                placeholder="Ej: Colombia, Venezuela, etc."
                className={errors.country ? 'error-input' : ''}
              />
              {errors.country && <span className="error-message">{errors.country}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="province">Provincia</label>
              <input
                type="text"
                id="province"
                name="province"
                value={formData.province}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                placeholder="Ej: Madrid, Barcelona, Valencia"
                className={errors.province ? 'error-input' : ''}
              />
              {errors.province && <span className="error-message">{errors.province}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="appointmentType">Tipo de Cita</label>
              <select
                id="appointmentType"
                name="appointmentType"
                value={formData.appointmentType}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                className={errors.appointmentType ? 'error-input' : ''}
              >
                <option value="">Selecciona un tipo</option>
                <option value="Asilo (Primera Solicitud y Renovaciones)">Asilo (Primera Solicitud y Renovaciones)</option>
                <option value="NIE (Asignación y Renovación)">NIE (Asignación y Renovación)</option>
                <option value="Huellas / Toma de Huellas (TIE)">Huellas / Toma de Huellas (TIE)</option>
                <option value="Otras Citas de Extranjería">Otras Citas de Extranjería</option>
              </select>
              {errors.appointmentType && <span className="error-message">{errors.appointmentType}</span>}
            </div>
            <button type="submit" className="submit-button">
              Enviar Solicitud
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
